/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';

import Modal from 'components/modals/Modal';

const DownloadReportModal = ({
  t, visible, setVisible, reportPdfUrl,
}) => {
  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
    >
      <div className="modal-content">
        <div className="modal-body">
          <div className="d-flex justify-content-center mb-30">
            <i className="fa-solid fa-cloud-download text-yellow2 fs-55" />
          </div>
          <div className="fs-18 fw-900 text-center mb-2">{t('downloadInspectionReport')}</div>
          <div className="text-center mb-45">Uzman ekibimiz tarafından hazırlanan ekspertiz raporunu indirerek, makina hakkında detaylı bilgiye sahip olabilirsiniz.</div>
          <div className="row">
            <div className="col-15 col-sm mb-3 mb-sm-0">
              <a href={reportPdfUrl} className="im-button im-button--gutter-10 im-button--fluid im-button--gray-outline-yellow text-center">
                <div className="flex-grow-1">
                  <div className="fs-14 fw-900 lh-1p4">PDF indir</div>
                  {/*  <div className="fs-14 fw-500">12.8 mb</div> */}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

DownloadReportModal.propTypes = {
  t: PropTypes.func,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  reportPdfUrl: PropTypes.string,
};

export default withTranslation('common')(DownloadReportModal);
